import { render, staticRenderFns } from "./desktop.vue?vue&type=template&id=9038961a&scoped=true&"
import script from "./desktop.vue?vue&type=script&lang=js&"
export * from "./desktop.vue?vue&type=script&lang=js&"
import style0 from "./desktop.vue?vue&type=style&index=0&id=9038961a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9038961a",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/FooterNavigation/desktop.vue
// module id = null
// module chunks = 